import { render, staticRenderFns } from "./ImageDeleteDialog.vue?vue&type=template&id=666d2938&"
import script from "./ImageDeleteDialog.vue?vue&type=script&lang=js&"
export * from "./ImageDeleteDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports